<main class="content-area">
  <div class="approvals">
    <app-page-header>
      <h1 class="text-2xl font-bold text-vms-text-dark tracking-tight">
        Pending Approvals
      </h1>
      <p class="text-sm text-slate-500 mt-1">
        <!-- Review and approve vendor registrations <span class="font-bold">({{ pendingCount }}) pending</span> -->
        Review and approve vendor registrations
      </p>
    </app-page-header>

    <div class="segmented">
      <button
        type="button"
        class="segmented__btn"
        [class.is-active]="selectedApprovalStatus === 'PENDING'"
        (click)="setSelectedApprovalStatus('PENDING')"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
          <g clip-path="url(#clip0_27_958)">
            <path d="M14.535 6.66373C14.8395 8.15793 14.6225 9.71135 13.9203 11.0649C13.218 12.4185 12.073 13.4904 10.6761 14.1019C9.27913 14.7135 7.71479 14.8276 6.24391 14.4253C4.77302 14.023 3.4845 13.1287 2.59323 11.8913C1.70195 10.654 1.26179 9.14856 1.34615 7.62599C1.43051 6.10342 2.0343 4.65579 3.05681 3.52451C4.07932 2.39323 5.45876 1.64668 6.96509 1.40937C8.47141 1.17205 10.0136 1.4583 11.3344 2.2204M6.00104 7.3304L8.00104 9.3304L14.6677 2.66373" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
          <defs>
            <clipPath id="clip0_27_958">
              <rect width="16" height="16" fill="white"/>
            </clipPath>
          </defs>
        </svg>
        <p>Pending</p>
      </button>
      <button
        type="button"
        class="segmented__btn"
        [class.is-active]="selectedApprovalStatus === 'APPROVED'"
        (click)="setSelectedApprovalStatus('APPROVED')"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
          <g clip-path="url(#clip0_27_958)">
            <path d="M14.535 6.66373C14.8395 8.15793 14.6225 9.71135 13.9203 11.0649C13.218 12.4185 12.073 13.4904 10.6761 14.1019C9.27913 14.7135 7.71479 14.8276 6.24391 14.4253C4.77302 14.023 3.4845 13.1287 2.59323 11.8913C1.70195 10.654 1.26179 9.14856 1.34615 7.62599C1.43051 6.10342 2.0343 4.65579 3.05681 3.52451C4.07932 2.39323 5.45876 1.64668 6.96509 1.40937C8.47141 1.17205 10.0136 1.4583 11.3344 2.2204M6.00104 7.3304L8.00104 9.3304L14.6677 2.66373" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
          <defs>
            <clipPath id="clip0_27_958">
              <rect width="16" height="16" fill="white"/>
            </clipPath>
          </defs>
        </svg>

        <p>All Approved</p>
      </button>
    </div>

    <div class="grid-area">
      <section class="left-card">
        <div class="my-3">
          <div class="relative w-full sm:w-[520px]">
            <svg
              class="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400 pointer-events-none"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
            <button
              type="button"
              (click)="openFilters()"
              class="w-full pl-9 pr-4 py-2 text-sm bg-slate-50 border border-slate-200 rounded-lg text-left text-slate-700 focus:outline-none focus:ring-2 focus:ring-teal-500/30 focus:border-teal-500 transition-all duration-200"
            >
              {{
                activeFilterCount
                  ? activeFilterCount +
                    " active filter" +
                    (activeFilterCount > 1 ? "s" : "")
                  : "Search and filter vendors"
              }}
            </button>
          </div>
        </div>
        <div class="table-wrap">
          <table class="table">
            <thead>
              <tr>
                <th class="text-nowrap">Creation Date</th>
                <th class="text-nowrap">Last Updated</th>
                <th class="text-nowrap">Application ID</th>
                <th class="text-nowrap">Applicant Name</th>
                <th class="text-nowrap">Status</th>
                <th class="text-nowrap">Payment Status</th>
              </tr>
            </thead>
            <tbody>
              @if (isLoadingWorkflowHistory) {
                <tr>
                  <td colspan="7" class="px-6 py-16 text-center">
                    <div class="flex flex-col items-center gap-3">
                      <div
                        class="h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-vms-bg-secondary"
                      ></div>
                      <p class="text-sm font-medium text-slate-500">
                        Loading approvals...
                      </p>
                    </div>
                  </td>
                </tr>
              } @else {
                @for (a of applications; track $index) {
                  <tr
                    (click)="selectApproval(a)"
                    [class.is-selected]="selectedApplication?.id === a.id"
                    class="transition-colors duration-150 animate-row-in"
                  >
                    <td>{{ (a.createdAt | date:'dd/MM/yyyy') || 'N/A' }}</td>
                    <td>{{ (a.updatedAt | date:'dd/MM/yyyy') || 'N/A' }}</td>
                    <td>{{ a.applicationRef || 'N/A' }}</td>
                    <td>{{ a.name || 'N/A' }}</td>
                    <td>
                      <div
                        class="size-fit py-1 px-3 font-bold"
                        [class]="getApplicationStatusColor(a.status)">
                        {{ a.status || 'N/A' }}
                      </div>
                    </td>
                    <td>
                      <div
                        class="size-fit py-1 px-3 bg-gray-50 text-xs rounded-2xl"
                        [class]="getPaymentStatusColor(a.paymentStatus)"
                      >
                        {{ a.paymentStatus || 'N/A' }}
                      </div>
                    </td>
                  </tr>
                } @empty {
                  <tr>
                    <td colspan="7" class="empty">No records</td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
        <div
            class="flex items-center justify-between px-6 py-4 border-t border-slate-100 bg-slate-50/50"
          >
          <p class="text-xs text-slate-400">
            Showing {{ applications.length }} of {{ totalItems }} applications
          </p>
          <div class="flex items-center gap-1">
            <button
              (click)="goToPreviousPage()"
              [disabled]="!hasPreviousPage"
              class="px-3 py-1.5 text-xs text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-md transition-colors duration-150 disabled:opacity-40"
            >
              Previous
            </button>
            <button
              class="px-3 py-1.5 text-xs bg-vms-bg-secondary text-white rounded-md shadow-sm"
            >
              {{ currentPage }}
            </button>
            <button
              (click)="goToNextPage()"
              [disabled]="!hasNextPage"
              class="px-3 py-1.5 text-xs text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-md transition-colors duration-150 disabled:opacity-40"
            >
              Next
            </button>
          </div>
        </div>
      </section>

      @if (selectedApplication) {
        <div class="application-detail">
          @if (!isLoadingApplicationDetails) {
            <div class="application-detail__header">
              <div>
                <div class="flex items-start gap-3">
                  <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M25.4243 30.5057H35.5935M25.4243 20.3365H35.5935M35.5935 53.3864V45.7595C35.5935 44.411 35.0578 43.1177 34.1043 42.1642C33.1508 41.2106 31.8575 40.6749 30.5089 40.6749C29.1604 40.6749 27.8671 41.2106 26.9136 42.1642C25.96 43.1177 25.4243 44.411 25.4243 45.7595V53.3864M15.2551 25.4211H10.1705C8.82202 25.4211 7.52873 25.9568 6.57518 26.9104C5.62163 27.8639 5.08594 29.1572 5.08594 30.5057V48.3018C5.08594 49.6503 5.62163 50.9436 6.57518 51.8972C7.52873 52.8507 8.82202 53.3864 10.1705 53.3864H50.8474C52.1959 53.3864 53.4892 52.8507 54.4427 51.8972C55.3963 50.9436 55.932 49.6503 55.932 48.3018V22.8788C55.932 21.5303 55.3963 20.237 54.4427 19.2834C53.4892 18.3299 52.1959 17.7942 50.8474 17.7942H45.7627M15.2551 53.3864V12.7096C15.2551 11.3611 15.7908 10.0678 16.7444 9.11425C17.6979 8.1607 18.9912 7.625 20.3397 7.625H40.6781C42.0267 7.625 43.32 8.1607 44.2735 9.11425C45.2271 10.0678 45.7627 11.3611 45.7627 12.7096V53.3864" stroke="#00637C" stroke-width="3.72039" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div>
                    <div class="application-detail__name">{{ selectedApplication?.name || 'N/A' }}</div>
                    <div class="application-detail__meta">
                      {{ applicationDetails?.metaData?.vendorReference || 'N/A' }} &nbsp; | &nbsp; ASIN-{{ applicationDetails?.metaData.asin || 'N/A' }}
                    </div>
                    <div class="application-detail__tag">Category {{ applicationDetails?.metaData?.categoryName || 'N/A' }}</div>
                  </div>
                </div>
              </div>
              <div class="application-detail__pill" [class]="getApplicationStatusPillColor(applicationDetails?.metaData?.approvalStatus)">
                {{ applicationDetails?.metaData?.approvalStatus || 'N/A' }}
              </div>
            </div>

            <div>
              <div class="mt-6 flex flex-wrap justify-between gap-1">
                <button type="button" class="tab-pill" [class.tab-pill--active]="tab === 'overview'" (click)="tab = 'overview'">
                  Overview
                </button>
                <button type="button" class="tab-pill" [class.tab-pill--active]="tab === 'directors'" (click)="tab = 'directors'">
                  Directors
                </button>
                <button type="button" class="tab-pill" [class.tab-pill--active]="tab === 'bank'" (click)="tab = 'bank'">
                  Bank Details
                </button>
                <button type="button" class="tab-pill" [class.tab-pill--active]="tab === 'documents'" (click)="tab = 'documents'">
                  Documents
                </button>
                <button type="button" class="tab-pill" [class.tab-pill--active]="tab === 'comments'" (click)="tab = 'comments'">
                  Comments
                </button>
              </div>
            </div>

            <div class="application-detail__kv">
              @switch (tab) {
                @case ('overview') {
                  <div class="kv"><span>Phone</span><strong>{{ applicationDetails?.overview?.phoneNumber || 'N/A' }}</strong></div>
                  <div class="kv"><span>Address</span><strong>{{ applicationDetails?.overview?.address || 'N/A' }}</strong></div>
                  <div class="kv"><span>RC Number</span><strong>{{ applicationDetails?.overview?.rcNumber || 'N/A' }}</strong></div>
                  <div class="kv"><span>Business Classification</span><strong>{{ (applicationDetails?.overview?.businessClassification | underscore | titlecase )|| 'N/A' }}</strong></div>
                  <div class="kv"><span>Date of Incorporation</span><strong>{{ applicationDetails?.overview?.dateOfIncorporation || 'N/A' }}</strong></div>
                  <div class="kv"><span>TIN</span><strong>{{ applicationDetails?.overview?.tin || 'N/A' }}</strong></div>
                  <div class="kv"><span>MDA Association</span><strong>{{ applicationDetails?.overview?.mdaAssociation || 'N/A' }}</strong></div>
                  <div class="kv"><span>Nature of Service</span><strong>{{ applicationDetails?.overview?.natureOfService || 'N/A' }}</strong></div>
                  <div class="kv"><span>Payment Amount</span><strong>{{ formatCurrency(applicationDetails?.overview?.paymentAmount) || 'N/A' }}</strong></div>
                  <div class="kv"><span>Vendor Type</span><strong>{{ applicationDetails.metaData.vendorType}}</strong></div>
                }
                @case ('directors') {
                  <div class="space-y-6">
                    @for (director of applicationDetails?.directors; track $index; let i = $index) {
                      <div>
                        <p class="mb-2 text-lg font-bold">Director {{i + 1}}</p>
                        <div class="kv"><span>ASIN</span><strong>{{ director?.asin || 'N/A' }}</strong></div>
                        <div class="kv"><span>Name</span><strong>{{ director?.name || 'N/A' }}</strong></div>
                        <div class="kv"><span>Phone Number</span><strong>{{ director?.phoneNumber }}</strong></div>
                        <div class="kv"><span>Email</span><strong>{{ director?.email }}</strong></div>
                        <div class="kv"><span>Address</span><strong>{{ director?.address }}</strong></div>
                        <div class="kv"><span>BVN</span><strong>{{ director?.bvn }}</strong></div>
                      </div>

                      @if (i < applicationDetails?.directors?.length) {
                        <hr class="border border-dashed">
                      }
                    }
                  </div>
                }
                @case ('bank') {
                  <div class="kv"><span>Account Number</span><strong>{{ applicationDetails?.bankDetails?.accountNumber || 'N/A' }}</strong></div>
                  <div class="kv"><span>Account Name</span><strong>{{ applicationDetails?.bankDetails?.accountName || 'N/A' }}</strong></div>
                  <div class="kv"><span>Bank</span><strong>{{ applicationDetails?.bankDetails?.bank || 'N/A' }}</strong></div>
                }
                @case ('documents') {
                  <div class="space-y-4">
                    @for (document of applicationDetails.documents; track $index) {
                      <div class="flex flex-wrap items-center justify-between gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4">
                        <div class="flex min-w-[240px] items-center gap-4">
                          <div class="h-10 w-10 rounded-xl bg-slate-50 grid place-items-center border border-slate-200">
                            <span class="text-xs font-semibold text-red-500">PDF</span>
                          </div>
                          <div class="min-w-0">
                            <a
                              class="page-link truncate"
                              [href]="document.url || '#'"
                              target="_blank"
                              rel="noopener noreferrer"
                            >{{ document.name }}</a>
                            <div class="mt-1 text-sm text-slate-400">Uploaded: {{ document.uploadedAt }}</div>
                          </div>
                        </div>

                        @if ((applicationDetails.metaData.approvalStatus).toUpperCase() === 'APPROVED') {
                          <span class="inline-flex items-center rounded-full bg-sky-100 px-4 py-1.5 text-sm font-medium text-sky-700">
                            Verified
                          </span>
                        } @else {
                          <span class="inline-flex items-center rounded-full bg-amber-100 px-4 py-1.5 text-sm font-medium text-amber-700">
                            Pending
                          </span>
                        }
                      </div>
                    }
                  </div>
                }
                @case ('comments') {
                  <div class="space-y-6">
                    @for (comment of applicationDetails?.commments; track $index; let i = $index) {
                      <div>
                        <p class="mb-2 text-lg font-bold">Comment {{i + 1}}</p>
                        <div class="kv"><span>User</span><strong>{{ comment?.user || 'N/A' }}</strong></div>
                        <div class="kv"><span>Comment</span><strong>{{ comment?.comment || 'N/A' }}</strong></div>
                        <div class="kv"><span>Created On</span><strong>{{ (comment?.createdAt | date:'dd/MM/yyyy') || 'N/A' }}</strong></div>
                      </div>

                      @if (i < applicationDetails?.commments?.length) {
                        <hr class="border border-dashed">
                      }
                    } @empty {
                      <div>No comments</div>
                    }
                  </div>
                }
              }
            </div>

            @if (selectedApprovalStatus === "PENDING") {
              <div class="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
                <button (click)="approveApplication()" class="p-2 flex items-center justify-center gap-2 bg-green-700 text-white rounded-md">
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.1693 4.25L6.3776 12.0417L2.83594 8.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <p>Approve</p>
                </button>
                <button (click)="queryApplication()" class="p-2 flex items-center justify-center gap-2 bg-amber-200 text-amber-700 rounded-md">
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_22_2948)">
                      <path d="M6.43615 6.3724C6.60268 5.89899 6.93138 5.4998 7.36403 5.24553C7.79668 4.99126 8.30536 4.89831 8.79998 4.98315C9.29459 5.06799 9.74322 5.32514 10.0664 5.70906C10.3896 6.09298 10.5665 6.57889 10.5657 7.08073C10.5657 8.4974 8.44073 9.20573 8.44073 9.20573M8.4974 12.0391H8.50448M15.5807 8.4974C15.5807 12.4094 12.4094 15.5807 8.4974 15.5807C4.58538 15.5807 1.41406 12.4094 1.41406 8.4974C1.41406 4.58538 4.58538 1.41406 8.4974 1.41406C12.4094 1.41406 15.5807 4.58538 15.5807 8.4974Z" stroke="#DC8F01" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_22_2948">
                        <rect width="17" height="17" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                  <p>Query</p>
                </button>
              </div>
            }
          } @else {
            <div class="h-full flex items-center justify-center">
              <div class="flex flex-col items-center gap-3">
                <div
                  class="h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-vms-bg-secondary"
                ></div>
                <p class="text-sm font-medium text-slate-500 text-center">
                  Loading application details...
                </p>
              </div>
            </div>
          }
        </div>
      } @else {
        <section class="right-card empty-state">
          Select an approval to review.
        </section>
      }
    </div>
  </div>
</main>

@if (isQueryModalOpen) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 px-4" (click)="closeQueryModal()">
    <div class="w-full max-w-lg rounded-2xl bg-white border border-slate-200 shadow-xl overflow-hidden" (click)="$event.stopPropagation()">
      <div class="px-6 py-4 border-b border-slate-100 flex items-center justify-between">
        <h3 class="text-base font-semibold text-slate-800">Query Vendor</h3>
        <button type="button" class="h-9 w-9 rounded-lg hover:bg-slate-100 text-slate-500" (click)="closeQueryModal()" aria-label="Close">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
      </div>

      <div class="p-6">
        <label class="block text-sm font-medium text-slate-700 mb-2">Reason / Message</label>
        <textarea
          class="w-full min-h-32 rounded-xl border border-slate-300 px-4 py-3 text-sm outline-none focus:border-teal-600 focus:ring-4 focus:ring-teal-100"
          [(ngModel)]="queryMessage"
          placeholder="Type your query message..."
        ></textarea>

        <div class="mt-5 flex items-center justify-end gap-3">
          <button type="button" class="page-btn page-btn-secondary" (click)="closeQueryModal()">Cancel</button>
          <button type="button" class="page-btn page-btn-primary" (click)="submitQuery()">Send Query</button>
        </div>
      </div>
    </div>
  </div>
}


@if (showModal) {
  <app-approval-or-query-modal
    [isOpen]="showModal"
    (submitted)="fetchWorkflowHistory()"
    [mode]="mode"
    [applicationDetails]="applicationDetails"
    (closed)="showModal = false"
    (submitted)="handleModalSubmission()"
  ></app-approval-or-query-modal>
}


<app-filter-drawer
  [isOpen]="isFilterDrawerOpen"
  title="Filters"
  subtitle="Search and filter vendors."
  submitLabel="Apply Filters"
  resetLabel="Clear all"
  [fields]="approvalFilterFields"
  [initialValue]="applyFilters"
  (close)="closeFilters()"
  (apply)="applyFilters($event)"
></app-filter-drawer>
